<template>
  <div class="common-padding-left common-padding-right">
    <div class="row">
      <div class="col col-12 col-md-3 col-lg-3"><SideBar :dataList="dataList" /></div>
      <div class="col col-12 col-md-9 col-lg-9 common-padding-top">
        <h1>交易查询</h1>
        <p>所有的交易结果通过该接口查询</p>
        <h4>接口说明</h4>
        <div class="font-12 common-padding-bottom-2">
          <div><span class="font-weight-bold">测试URL：</span><span>http://test.api.route.hangmuxitong.com</span></div>
          <div><span class="font-weight-bold">生产URL：</span><span>https://api.yunfastpay.com</span></div>
          <div><span class="font-weight-bold">请求方式：</span><span>POST</span></div>
          <div>dome请见QueryTrans，<router-link tag="a" :to="{path:'/interface/zysm'}">下载deom</router-link>
          </div>
        </div>
        <h4>请求参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>TRANS0102</td></tr>
          <tr><td>商户号</td><td>mchtCd</td><td>String（15）</td><td>是</td><td></td></tr>
          <tr><td>原交易日期</td><td>oglOrdDate</td><td>String（8）</td><td>是</td><td>格式：yyyyMMdd</td></tr>
          <tr><td>原订单号</td><td>oglOrdId</td><td>String（32）</td><td>是</td><td>合作方订单号，或平台订单号</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
        <h4>应答参数</h4>
        <table class="table table-bordered table-striped">
          <thead>
          <tr>
            <th>参数名</th>
            <th>变量</th>
            <th>类型</th>
            <th>是否必填</th>
            <th>说明</th>
          </tr>
          </thead>
          <tbody class="font-12">
          <tr><td>交易码</td><td>trscode</td><td>String（32）</td><td>是</td><td>TRANS0110</td></tr>
          <tr><td>机构号</td><td>orgCd</td><td>String（32）</td><td>否</td><td></td></tr>
          <tr><td>商户号</td><td>mchtCd</td><td>String（20）</td><td>是</td><td></td></tr>
          <tr><td>商户名</td><td>mchtName</td><td>String（150）</td><td>否</td><td></td></tr>
          <tr><td>外部订单号</td><td>outOrderId</td><td>String（32）</td><td>是</td><td>下游上送的交易流水号</td></tr>
          <tr><td>原交易平台流水号</td><td>oglOrderCd</td><td>String(20)</td><td>是</td><td>下单交易流水号</td></tr>
          <tr><td>交易金额</td><td>transAmt</td><td>String（10）</td><td>否</td><td>单位（元）</td></tr>
          <tr><td>退款金额</td><td>refundAmount</td><td>String（10）</td><td>否</td><td>单位（元）</td></tr>
          <tr><td>支付方式</td><td>payType</td><td>String（10）</td><td>否</td><td>支付宝“alipay”,微信支付“wxpay”</td></tr>
          <tr><td>交易状态</td><td>transStatus</td><td>String（10）</td><td>否</td><td>100-支付成功（支付订单）或退款成功（退款订单）
            101-待支付
            102-支付失败（支付订单）或退款失败（退款订单）
            103-订单处理中
            104-已撤销
          </td></tr>
          <tr><td>付款人编号</td><td>buyerCd</td><td>String（10）</td><td>否</td><td></td></tr>
          <tr><td>交易卡类型</td><td>bankType</td><td>String（10）</td><td>否</td><td>银行类型，采用字符串类型的银行标识
            包含"DEBIT" 借记卡  "CREDIT"信用卡其他
          </td></tr>
          <tr><td>商户费率</td><td>mchtRate</td><td>String（10）</td><td>否</td><td></td></tr>
          <tr><td>客户电话</td><td>memTel</td><td>String（15）</td><td>否</td><td></td></tr>
          <tr><td>商户省代码</td><td>provinceCode</td><td>String（10）</td><td>否</td><td></td></tr>
          <tr><td>商户市代码</td><td>cityCode</td><td>String（10）</td><td>否</td><td></td></tr>
          <tr><td>商户区代码</td><td>districtCode</td><td>String（10）</td><td>否</td><td></td></tr>
          <tr><td>支付成功时间</td><td>transDatetime</td><td>String（16）</td><td>否</td><td>yyyyMMddHHmmss</td></tr>
          <tr><td>结算日期</td><td>settleDate</td><td>String（8）</td><td>否</td><td>yyyyMMdd</td></tr>
          </tbody>
        </table>
        <h4>请求示例</h4>
        <p>见demo</p>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from '@/pages/interface/components/SideBar'
export default {
  name: 'Cx',
  components: {
    SideBar
  },
  data () {
    return {
      dataList: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/interface/components/Cx.vue